import { Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, Divider, FormControlLabel, Grid, IconButton, TextField, Typography } from '@mui/material';
import { GridCloseIcon } from '@mui/x-data-grid';
import { DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import React, { useEffect, useLayoutEffect } from 'react'
import RestAPIService from '../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../Utility/API/Serviceurls';
import ToastMsg from '../ToastMsg/ToastMsg';
import { getBillDateTime, getBillHelperText, getReceiptDateTime, getReceiptHelperText } from '../CommonFunctions/CommonFunctions';

export default function ModifyDatePopup(props) {
    const [isErrorStatus, setErrorStatus] = React.useState(false)
    const [errorMsg, setErrorMsg] = React.useState("")
    const [btnDisable, setBtnDisable] = React.useState(false)
    const [isSuccStatus, setSuccStatus] = React.useState(false)
    const [succMsg, setSuccMsg] = React.useState("")
    const [billDate, setBillDate] = React.useState({});
    const [billState, setBillState] = React.useState({});
    const [startPickerOpen, setStartPickerOpen] = React.useState(false)

     const {
            //Bills
            selectedBillData,
            isReceiptBill,
            appointmentDateTime,
            invoiceDateTime,
            isSelfPatient,
            isFutureAppointmentPatient,
            //common
            modifyDateTime,
            modifyBillLoading,
            //Receipts
            selectedReceiptData,
            modifyReceiptDateTime,
        } = billState;
    const { 
        selectedData, 
        onClose, 
        onSuccess, 
        Bills,
        isLoading,
    } = props;

    const errorMessage = (message) => {
        setErrorStatus(true)
        setErrorMsg(message)
        setBtnDisable(false)
    }

    const successMessage = (message) => {
        setSuccMsg(message)
        setSuccStatus(true)
    }

    const msgClose = () => {
        setErrorStatus(false)
        setErrorMsg('')
        setSuccMsg('')
        setSuccStatus(false)
    }

    useEffect(() => {
        if (Bills) {
            handleOpenModifyDatePopup(selectedData);
        }else{
            rechandleOpenModifyDatePopup(selectedData);
        }
    }, [selectedData]);


    useLayoutEffect(() => {
        if(selectedData?.id && selectedData?.payment_status !== "not paid" && Bills){
            getMultipleBillsAgainstReceipt()
        }
    },[selectedData?.id])

    const getMultipleBillsAgainstReceipt = () => {
        try {
            RestAPIService.getAll(Serviceurls.GET_BILLS_AGAINST_RECEIPT + `/?bill_id=${selectedData?.id}`)
                .then(response => {
                    if (response.data.status === 'success') {
                        const billsData = response.data.data || {};
                        setBillDate(billsData);
                    } else {
                        errorMessage(response.data.message)
                    }
                }).catch(error => {
                    const errorMsg = error?.response?.data?.message || error.message;
                    errorMessage(errorMsg);
                })
        } catch (error) {
            errorMessage(error.message);
        }
    }

    const handleModifyDateSubmit = async () => {
        const { modifyDateTime, selectedBillData, isReceiptBill, appointmentDateTime, invoiceDateTime, } = billState;

        // Basic validation
        if (!modifyDateTime || !modifyDateTime.isValid()) {
            errorMessage('Please select a valid date and time');
            return;
        }

        const existingDate = dayjs(selectedBillData?.invoice_date, 'DD-MM-YYYY hh:mm A');
        if(modifyDateTime.isSame(existingDate)){
            errorMessage('Selected date is same as current bill date. Please select a different date and time.');
            return;
        }

        // Convert appointmentDateTime to dayjs if it's a string
        let appointmentDateObj = appointmentDateTime;
        if (typeof appointmentDateTime === 'string') {
            appointmentDateObj = dayjs(appointmentDateTime, 'DD-MM-YYYY hh:mm A');
        }

        // Convert invoiceDateTime to dayjs if it's a string  
        let invoiceDateObj = invoiceDateTime;
        if (typeof invoiceDateTime === 'string') {
            invoiceDateObj = dayjs(invoiceDateTime, 'DD-MM-YYYY hh:mm A');
        }

        // Validate against appointment date
        if (appointmentDateObj && appointmentDateObj.isValid() && modifyDateTime.isValid()) {
            if (modifyDateTime.isBefore(appointmentDateObj)) {
                errorMessage('Selected date cannot be before appointment date');
                return;
            }
        }

        // Validate against invoice date
        if (invoiceDateObj && invoiceDateObj.isValid() && modifyDateTime.isValid()) {
            if (modifyDateTime.isAfter(invoiceDateObj)) {
                errorMessage('Selected date cannot be after invoice date');
                return;
            }
        }

        // Additional validation: Ensure date is not in the future (if needed)
        const now = dayjs();
        if (modifyDateTime.isAfter(now)) {
            errorMessage('Selected date cannot be in the future');
            return;
        }

        const formattedDateTime = modifyDateTime.format('YYYY-MM-DD HH:mm:ss');

        const data = {
            id: selectedBillData?.id || selectedBillData?.bill_summary_id,
            bill_date_time: formattedDateTime,
            include_receipt: isReceiptBill,
        };

        try {
            setBillState(prev => ({ ...prev, modifyBillLoading: true }));
            setBtnDisable(true); 

            RestAPIService.create(data, Serviceurls.MODIFY_BILL_DATE)
                .then((response) => {
                    if (response.data.status === "success") {
                       successMessage(response.data.message);
                       onSuccess(); 
                    } else {
                       setBillState(prev => ({ ...prev, modifyBillLoading: false }));
                       errorMessage(response.data.message);
                    }
                })
                .catch((error) => {
                    const errorMsg = error?.response?.data?.message || error.message;
                    setBillState(prev => ({ ...prev, modifyBillLoading: false }));
                   errorMessage(errorMsg);
                })
        } catch (error) {
           errorMessage(error.message);
           setBillState(prev => ({ ...prev, modifyBillLoading: false }));
        }
    }

    const  handleModifyReceiptDateSubmit = async () => {
        const { modifyDateTime, selectedReceiptData } = billState;

        if (!modifyDateTime || !modifyDateTime.isValid()) {
            errorMessage(('Please select a valid date and time'));
            return;
        }

        const existingDate = dayjs(selectedReceiptData?.invoice_date, 'DD-MM-YYYY hh:mm A');
        if(modifyDateTime.isSame(existingDate)){
            errorMessage(('Selected date is same as current receipt date. Please select a different date and time.'));
            return;
        }

        const formattedDateTime = modifyDateTime.format('YYYY-MM-DD HH:mm:ss');

        const data = {
            id: selectedReceiptData?.id,
            receipt_date_time: formattedDateTime,
        };

        try {
            setBillState(prev => ({ ...prev, modifyBillLoading: true }));
            setBtnDisable(true); 

            const API_URL = Serviceurls.MODIFY_RECEIPT_DATE;

            RestAPIService.create(data, API_URL)
                .then((response) => {
                    if (response.data.status === "success") {
                        successMessage(response.data.message);
                        onSuccess();
                    } else {
                        setBillState(prev => ({ ...prev, modifyBillLoading: false }));
                        errorMessage(response.data.message);
                    }
                })
                .catch((error) => {
                    const errorMsg = error?.response?.data?.message || error.message;
                    setBillState(prev => ({ ...prev, modifyBillLoading: false }));
                    errorMessage(errorMsg);
                })
        } catch (error) {
            errorMessage(error.message);
            setBillState(prev => ({ ...prev, modifyBillLoading: false }));
        }
    }

    
    const handleOpenModifyDatePopup = (billData) => {
        let invoiceDate = null;
        let formattedInvoiceStr = '';
        if (billData?.invoice_date) {
            formattedInvoiceStr = billData.invoice_date;
            invoiceDate = dayjs(billData.invoice_date, 'DD-MM-YYYY hh:mm A');
        }

        let appointmentDate = null;
        let formattedAppointmentStr = '';

        // let isFutureAppointmentPatient = false;
        // if (billData?.appointment_date && invoiceDate) {
        //     const appointmentDateTemp = dayjs(billData.appointment_date, 'DD-MM-YYYY hh:mm A');
        //     isFutureAppointmentPatient = appointmentDateTemp.isAfter(invoiceDate);
        // }
        const isSelfPatient = billData?.appointment_id === null;

        if (isSelfPatient && billData?.created_date) {
            const created_date = dayjs(billData.created_date, 'DD-MM-YYYY hh:mm A');

            // For self patients or future appointment patients: appointment date = created date - 1 day
            appointmentDate = created_date.subtract(1, 'day')
            formattedAppointmentStr = appointmentDate.format('DD-MM-YYYY hh:mm A');
        } else if (billData?.appointment_date) {
             // For regular patients: use the actual appointment date
            formattedAppointmentStr = (billData.appointment_date);
            appointmentDate = dayjs(billData.appointment_date, 'DD-MM-YYYY hh:mm A');
        }

        setBillState({
            selectedBillData: billData,
            modifyDateTime: invoiceDate,
            isReceiptBill: false,
            appointmentDateTime: formattedAppointmentStr,
            invoiceDateTime: formattedInvoiceStr,
            isSelfPatient: isSelfPatient,
            // isFutureAppointmentPatient: isFutureAppointmentPatient,
        });
    }

    const rechandleOpenModifyDatePopup = (receiptData) => {
        let modifyDateTime = null;
        let InvoiceDate = receiptData?.invoice_date || receiptData?.receipt_date;
        //
        if (InvoiceDate) {
            if (InvoiceDate?.includes('-') && InvoiceDate?.includes(':')) {
                modifyDateTime = dayjs(InvoiceDate, 'DD-MM-YYYY hh:mm A');
            } else {
                const formattedDateTime = InvoiceDate;
                modifyDateTime = dayjs(formattedDateTime, 'DD-MM-YYYY hh:mm A');
            }
        }

        setBillState({
            showModifyDatePopup: true,
            selectedReceiptData: receiptData,
            modifyDateTime: modifyDateTime?.isValid() ? modifyDateTime : null,
            modifyReceiptLoading: false,
        });
    }
    const receiptDateSource = (selectedReceiptData?.invoice_date ? selectedReceiptData?.invoice_date : '') || selectedReceiptData?.receipt_date;
    const receiptDateTime = (selectedReceiptData?.receipt_for === "Cancelled" || selectedReceiptData?.receipt_for === "Refund") ?
     selectedReceiptData?.original_receipt_date : selectedReceiptData?.bill_date;
    const receipt_type = selectedReceiptData?.bill_type || selectedReceiptData?.receipt_for || '';


    return (
        <>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
          <Dialog
              open={true}
              disableEscapeKeyDown={true}
              onClose={() => {}}  
              maxWidth="sm"
              fullWidth
          >
              <DialogTitle style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  padding: '16px 24px',
                  borderBottom: '1px solid #e0e0e0',
                  backgroundColor: '#f5f5f5'
              }}>
                  <Typography variant="h6" style={{ fontWeight: 600 }}>
                      {(`Modify ${Bills ? 'Bill' : 'Receipt'} Date`)}
                  </Typography>
                  <IconButton
                      onClick={onClose}
                      size="small"
                      style={{ marginRight: -8 }}
                  >
                      <GridCloseIcon />
                  </IconButton>
              </DialogTitle>

              <DialogContent style={{ padding: '24px' }}>
                  {/* Bill Details */}
                  <Grid container spacing={2} style={{ marginBottom: 20 }}>
                      <Grid item xs={12}>
                          <Grid container justifyContent="space-between">
                              <Typography variant="body2" color="textSecondary">
                                  {('Bill Number')}
                              </Typography>
                              <Typography variant="body2" style={{ fontWeight: 600 }}>
                                  {Bills ? (selectedBillData?.bill_number || selectedBillData?.invoice_number ) : selectedReceiptData?.receipt_number }
                              </Typography>
                          </Grid>
                      </Grid>
                      <Grid item xs={12}>
                          <Grid container justifyContent="space-between" alignItems="center" wrap="nowrap">
                              <Typography variant="body2" color="textSecondary">
                                  {Bills ? ('Appointment Date & Time') : ('Bill Date & Time')}
                              </Typography>
                              <Typography variant="body2" sx={{ fontWeight: 600 }}>
                                      {Bills
                                          ? (appointmentDateTime
                                              ? (isSelfPatient
                                                  ? `${appointmentDateTime} (Self Patient - 1 day before bill date)`
                                                    : isFutureAppointmentPatient ? 
                                                        `${selectedBillData?.appointment_date} (Future Appointment - 1 day before bill date)`
                                                  : appointmentDateTime)
                                            : '' )
                                        : selectedReceiptData?.bill_date}
                              </Typography>
                          </Grid>
                      </Grid>
                      <Grid item xs={12}>
                          <Grid container justifyContent="space-between">
                              <Typography variant="body2" color="textSecondary">
                                  {Bills ? ('Created Date & Time') : ('Receipt Created Date & Time')}
                              </Typography>
                              <Typography variant="body2" style={{ fontWeight: 600 }}>
                                  {Bills ? selectedBillData?.created_date  : selectedReceiptData?.created_date }
                              </Typography>
                          </Grid>
                      </Grid>
                      <Grid item xs={12}>
                          <Grid container justifyContent="space-between">
                              <Typography variant="body2" color="textSecondary">
                                  {`${Bills ? 'Bill' : 'Receipt'} Type`}
                              </Typography>
                              <Typography variant="body2" style={{ fontWeight: 600 }}>
                                  {Bills ? selectedBillData?.bill_type ?
                                      selectedBillData.bill_type.charAt(0).toUpperCase() + selectedBillData.bill_type.slice(1)
                                      : ''
                                      : receipt_type ?
                                          receipt_type?.charAt(0)?.toUpperCase() + receipt_type?.slice(1)
                                          : ''}
                              </Typography>
                          </Grid>
                      </Grid>
                  </Grid>

                  <Divider style={{ margin: '16px 0' }} />

                  {/* Modify Section */}
                  <Typography variant="subtitle1" style={{ fontWeight: 600, marginBottom: 16 }}>
                      {(`Modify ${Bills ? 'Bill' : 'Receipt'} Date & Time`)}
                  </Typography>

                  <Grid container spacing={2} style={{ marginBottom: 20 }}>
                      <Grid item xs={12}>
                          <DateTimePicker
                              label={('Select Date & Time')}
                              value={modifyDateTime}
                              open={startPickerOpen} 
                              onOpen={() => setStartPickerOpen(true)}
                              onClose={() => setStartPickerOpen(false)}
                              onChange={(newValue) => {
                                  setBillState (prevState => ({
                                    ...prevState,
                                    modifyDateTime: newValue }));
                              }}
                              minDateTime={Bills ? getBillDateTime(appointmentDateTime) : getReceiptDateTime(receiptDateTime)}
                              maxDateTime={Bills ? getBillDateTime(selectedBillData?.invoice_date) : getReceiptDateTime(receiptDateSource)}
                              ampm={true}
                              format="dd-MM-yyyy hh:mm a"
                              inputFormat="DD-MM-YYYY hh:mm A"
                              renderInput={(params) => (
                                  <TextField
                                      {...params}
                                      fullWidth
                                      variant="outlined"
                                      size="small"
                                      onClick={() => setStartPickerOpen(true)}
                                      helperText={Bills ? getBillHelperText(getBillDateTime(appointmentDateTime), getBillDateTime(selectedBillData?.invoice_date), isSelfPatient, isFutureAppointmentPatient)
                                         : getReceiptHelperText(getReceiptDateTime(receiptDateTime), getReceiptDateTime(receiptDateSource))}
                                      error={false}
                                  />
                              )}
                          />
                      </Grid>
                  </Grid>

                  {/* Receipt Bill Checkbox */}
                  {Bills && selectedData?.payment_status !== "not paid" && !billDate?.is_multiple_bills ? <FormControlLabel
                      control={
                          <Checkbox
                              checked={isReceiptBill}
                              onChange={(e) => setBillState(prevState => ({ 
                                ...prevState,
                                isReceiptBill: e.target.checked,
                             }))}
                              color="primary"
                          />
                      }
                      label={('Receipt Bill')}
                      style={{ marginLeft: -11 }}
                  /> : null}

              </DialogContent>

              <DialogActions style={{
                  padding: '16px 24px',
                  borderTop: '1px solid #e0e0e0'
              }}>
                  <Button
                      onClick={onClose}
                      color="secondary"
                      variant="outlined"
                      disabled={modifyBillLoading}
                      style={{ minWidth: 100 }}
                  >
                      {('CANCEL')}
                  </Button>
                  <Button
                      onClick={Bills ? handleModifyDateSubmit : handleModifyReceiptDateSubmit}
                      color="primary"
                      variant="contained"
                      disabled={modifyBillLoading}
                      style={{ minWidth: 100 }}
                  >
                      {modifyBillLoading ? ('PROCESSING...') : ('MODIFY')}
                  </Button>
              </DialogActions>
          </Dialog>
      </LocalizationProvider>
          {(isErrorStatus && errorMsg) ?
              <ToastMsg
                  severity={'error'}
                  msg={errorMsg}
                  msgPop={msgClose}
              />
              : null}
          {(isSuccStatus && succMsg) ?
              <ToastMsg
                  severity={'success'}
                  msg={succMsg}
                  msgPop={msgClose}
              />
              : null}
      </>
  )
}